<template>
  <section class="section-padding">
    <div class="row">
      <div class="col-12 text-center">
        <template v-if="errorMessage">
          <i class="fal fa-times-circle fa-5x text-danger"></i>
          <h4 class="mt-4">{{ $t('message.payment_method.payment_failure') }}: {{ errorMessage }}</h4>
          <div class="mt-4">
            <router-link class="btn btn-info btn-lg"
                         :to="state.tmpBookingData.booking_uri">
              {{ $t('message.booking.navigation.back') }}
            </router-link>
          </div>
        </template>
        <template v-else>
          <div>
            <i class="fal fa-check-circle fa-5x text-success"></i>
            <h4 class="mt-4">
              {{ $t('message.booking.complete_step.title') }}
            </h4>
            <div class="mt-3" v-if="newOrderData">
              <router-link class="btn btn-info btn-lg"
                           :to="'/reservation/'+newOrderData.id">
                {{ $t('message.booking.complete_step.view_my_booking') }}
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        errorMessage: null
      }
    },
    computed: {
      ...mapGetters({
        state: 'booking/getState',
        isAddingOrder: 'booking/isAddingOrder',
        newOrderData: 'booking/getNewOrderData',
        payment: 'payment/getPayment',
        preBookingData: 'booking/getPreBookingData',
        user: 'auth/getUser'
      }),
      ...mapState('payment', [
        'tmpOmiseToken',
        'tmpIsDefaultCard'
      ])
    },
    watch: {
      payment () {
        if (this.payment) {
          // Clear payment data
          this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
          this.$store.commit('payment/SET_TMP_OMISE_TOKEN', null)

          // Prepare submit data
          const submitData = this.state.tmpBookingData
          submitData.omise_customer_id = this.payment.omise_customer_id

          // Check selected professional or not
          if (Number(submitData.selected_professional_id) > 0) {
            if (this.preBookingData.package_type) {
              this.$store.dispatch('booking/ADD_PACKAGE', submitData)
            } else {
              this.$store.dispatch('booking/ADD_ORDER', submitData)
            }
          } else {
            // Check create subscription
            if (submitData.subscription_type_id) {
              this.$store.dispatch('booking/ADD_SUBSCRIPTION', submitData)
            } else if (this.preBookingData.package_type) {
              this.$store.dispatch('booking/ADD_PACKAGE', submitData)
            } else {
              this.$store.dispatch('booking/ADD_ORDER', submitData)
            }
          }
        }
      },
      isAddingOrder () {
        // If complete adding order
        if (!this.state.isAddingOrder) {
          if (this.newOrderData) {
            // Clear tmp booking data
            this.$store.commit('booking/SET_TMP_BOOKING_DATA', null)
          }
        }
      }
    },
    async mounted () {
      if (this.tmpOmiseToken) {
        // Add new card
        const submitData = {
          user_id: this.user.id,
          omise_token: this.tmpOmiseToken,
          is_default: this.tmpIsDefaultCard
        }
        this.$store.commit('serviceRequest/SET_TMP_PAYMENT_CONFIRM_DATA', null)
        await this.$store.dispatch('payment/ADD_PAYMENT', submitData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/payment/PaymentValidation.vue